import { useCallback, useState } from 'react';

import { defaultLimit } from 'views/CRM/shared/utils/pagination';

import WhatsappBlockListService from '../../services';

export const useListActiveWhatsappBlockListReport = ({ sortConfig }) => {
  const [whatsappBlockNumbersReportList, setWhatsappBlockNumbersReportList] =
    useState([]);
  const [totalWhatsappBlockNumbersReport, setTotalWhatsappBlockNumbersReport] =
    useState(0);
  const [
    isLoadingWhatsappBlockNumbersReport,
    setIsLoadingWhatsappBlockNumbersReport
  ] = useState(false);

  const getWhatsappBlockNumbersReport = useCallback(
    (page = 1, params = {}) => {
      setIsLoadingWhatsappBlockNumbersReport(true);

      const orderType =
        sortConfig?.direction === null ||
        sortConfig?.direction === undefined ||
        sortConfig?.direction === 'ascending' ||
        sortConfig?.direction === 'ascendant'
          ? 'ASC'
          : 'DESC';

      let orderBy = sortConfig?.key;

      WhatsappBlockListService.listReport(
        { ...params, orderType, orderBy },
        { page, limit: defaultLimit }
      )
        .then((response) => {
          setWhatsappBlockNumbersReportList(response.data.data);
          setTotalWhatsappBlockNumbersReport(response.data.quantity);
        })
        .finally(() => setIsLoadingWhatsappBlockNumbersReport(false));
    },
    [sortConfig]
  );

  return {
    whatsappBlockNumbersReportList,
    totalWhatsappBlockNumbersReport,
    isLoadingWhatsappBlockNumbersReport,
    getWhatsappBlockNumbersReport
  };
};
